<template>
    <div id="registrarformview" class="reg-form-body form-condensed">
        <div class="panel-body" v-if="modeloform == 1">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-nome">
                        <label class="control-label has-star" for="regform-nome">Nome</label>
                        <input type="text" id="regform-nome" class="form-control" v-model="nome"
                               name="regform-nome" required="true" aria-required="true"
                               style="text-align: left;">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-email">
                        <label class="control-label has-star" for="regform-email">Email</label>
                        <input type="text" id="regform-email" class="form-control" v-model="email"
                               name="regform-email" required="true" aria-required="true"
                               style="text-align: left;">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-passwd">
                        <label class="control-label has-star" for="regform-passwd">Senha</label>
                        <input type="password" id="regform-passwd" class="form-control" v-model="senha"
                               name="regform-passwd" required="true" aria-required="true"
                               style="text-align: left;">
                        <password-meter :password="senha" @score="onScore"></password-meter>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-confirm">
                        <label class="control-label has-star" for="regform-confirm">Confirmação de senha</label>
                        <input type="password" id="regform-confirm" class="form-control" v-model="confirmar"
                               name="regform-confirm">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <div id="auth-container" class="form-row auth-anchor auth-anchor-normal auth-anchor-light">
                            <p class="auth-header">Eu não sou um robô</p>
                            <div class="col-md-6">
                                <p class="auth-texto">{{ this.texto_robo }}</p>
                            </div>
                            <div class="col-md-3">
                                <input type="text" class="form-control auth-resposta" id="regform-resposta"
                                       v-model="resposta" name="regform-resposta">
                            </div>
                            <div class="col-md-3">
                                <img :src="imagemRobot2" width="48px" height="48px" class="auth-robot">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="mensagemUsuario.length > 0">
                <div class="col-md-12">
                    <div class="alert-primary" role="alert">
                        <ul>
                            <li v-for="msg in mensagemUsuario">
                                {{ msg }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="pull-right">
                        <button id="btnProximo" class="btn btn-primary btn-lg btn-rounded" v-on:click.prevent="proximoForm">Próximo</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-termos">
                        <div class="checkbox"><label class="has-star">
                            <input type="checkbox" id="regform-termos"
                                   name="regform-termos" true-value="S"
                                   false-value="N" v-model="aceite">
                            <a href="#" onclick="window.open(route('public.termos'), '_blank');">
                                Declaro que li os termos do serviço</a>
                        </label>
                            <div class="help-block"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-body auth-empresa" v-if="modeloform == 2">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-cnpj">
                        <label class="control-label has-star" for="regform-cnpj">CNPJ</label>
                        <input type="text" id="regform-cnpj" class="form-control" v-model="cnpj" @blur="consultaCNPJ()"
                               name="regform-cnpj" required="true" aria-required="true" maxlength="18"
                               style="text-align: left;">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-empresa">
                        <label class="control-label has-star" for="regform-empresa">Empresa</label>
                        <input type="text" id="regform-empresa" class="form-control" v-model="nomeEmpresa"
                               name="regform-empresa" required="true" aria-required="true" maxlength="50"
                               style="text-align: left;" :disabled="consultado">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group highlight-addon field-regform-empresa">
                        <ul>
                            <li>
                                Porque pedimos o CNPJ:
                                <p>Precisamos para gerar cobrança bancária quando você optar por continuar a utilizar os serviços</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row" v-if="mensagemUsuario.length > 0">
                <div class="col-md-12">
                    <div class="alert alert-primary" role="alert">
                        <ul>
                            <li v-for="msg in mensagemUsuario">
                                {{ msg }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="pull-right">
                        <button class="btn btn-primary btn-lg btn-rounded" v-on:click.prevent="salvarEtapa">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-body auth-empresa" v-if="modeloform == 4">
            <div class="row">
                <div class="panel-heading text-center">
                    <h3 class="text-primary">Registrado com sucesso</h3>
                    <h4 class="text-primary">Você receberá um email para validar seu cadastro.</h4>
                </div>
            </div>
        </div>
        <div class="auth-empresa text-center" v-if="processando">
            <LoadingBar/>
        </div>
    </div>
</template>

<script>
import passwordMeter from "vue-simple-password-meter";
import {validate} from 'cnpj';
import LoadingBar from "./loadingbar.component";

export default {
    name: "registrarView",
    props: [
        'baseurl',
        'token_auth',
        'modulo',
        'texto_robo'
    ],
    components: {
        passwordMeter, LoadingBar
    },
    data: () => ({
        urlContexto: '',
        password: null,
        show: false,
        nome: '',
        email: '',
        senha: '',
        confirmar: '',
        aceite: 'N',
        forca: 0,
        resposta: '',
        imagemRobot: '',
        mensagemUsuario: [],
        modeloform: 1,
        pes_cod: 0,
        cnpj: '',
        nomeEmpresa: '',
        consultado: false,
        processando: false
    }),
    computed: {
        imagemRobot2() {
            // console.log(baseUrl);
            return "images/img_robot.png";
        }
    },
    mounted() {
        const {baseurl, token_auth, $el} = this;
        if (this.modulo === undefined || this.modulo === null) {
            console.log('Módulo vazio');
        }

    },
    updated: function () {
        this.$nextTick(function () {
            if (this.modeloform === 2) {
                $('#regform-cnpj').mask('##.###.###/####-##');
            }
        });
    },
    methods: {
        clearMensagem() {
            this.mensagemUsuario = [];
        },
        toggle() {
            this.show = !this.show
        },
        onScore({score, strength}) {
            this.forca = score;
        },
        async proximoForm() {
            var vm = this;

            // validar os dados
            this.processando = false;
            this.clearMensagem();
            if (this.nome == undefined || this.nome == "") {
                this.mensagemUsuario.push('Obrigatório informar o nome');
            }
            if (this.email == undefined || this.email == "") {
                this.mensagemUsuario.push('Obrigatório informar o email');
            }

            if (this.aceite == undefined || this.aceite !== "S") {
                this.mensagemUsuario.push('Aceite dos termos não informado');
            }

            if (this.resposta == undefined || this.resposta == "") {
                this.mensagemUsuario.push('Obrigatório informar a resposta da verificação de robô.');
            }

            if (this.mensagemUsuario.length > 0) {
                return;
            }

            if (this.forca < 2) {
                //Notificacao.toastWarn("A força da senha não é segura !");
                this.mensagemUsuario.push('Força da senha não é segura');
                return;
            }

            if (this.senha !== this.confirmar) {
                // Notificacao.toastWarn("As senhas não são iguais !");
                this.mensagemUsuario.push('As senhas não são iguais !');
                return;
            }

            // enviar dados

            const postData = {
                nome: this.nome,
                email: this.email,
                senha: this.senha,
                resposta: this.resposta,
                aceite: this.aceite,
                token_auth: this.token_auth
            };
            // console.log("postData");
            // console.dir(postData);
            this.processando = true;
            await axios.post('registrar/usuario', postData).then((response) => {
                let retorno = response.data;
                // console.log("retorno");
                // console.dir(retorno);
                if (retorno.id) {
                    vm.pes_cod = retorno.id;
                    vm.modeloform = 2;
                    vm.mensagemUsuario = [];
                }
            }).catch(function (error) {
                vm.processando = false;
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    // console.log(error.response.headers);
                    let retorno = error.response.data;
                    if (error.response.status === 500) {
                        vm.mensagemUsuario.push("Erro no processamento: " + retorno.exception);
                    } else if (retorno.status !== 200) {
                        vm.mensagemUsuario.push(retorno.msg);
                        return;
                    }
                } else {
                    console.error(error);
                    vm.mensagemUsuario.push('Ocorreu erro na sua requisição');
                    return;
                }
            }).finally(() =>{
                vm.processando = false;
            });
            // tratar retorno
        },
        async salvarEtapa() {
            var vm = this;
            this.processando = false;
            // validar os dados
            this.clearMensagem();
            if (this.cnpj == undefined || this.cnpj == "" || this.cnpj.length < 18) {
                this.mensagemUsuario.push('Obrigatório informar o CNPJ');
                return;
            }

            const valido = validate(this.cnpj);
            if (!valido) {
                this.mensagemUsuario.push('CNPJ inválido');
                return;
            }
            const postData = {
                pes_cod: this.pes_cod,
                nome: this.nomeEmpresa,
                cnpj: this.cnpj,
                modulo: this.modulo
            };
            this.processando = true;
            await axios.post('registrar/empresa', postData).then((response) => {
                let retorno = response.data;
                // console.log("retorno");
                // console.dir(retorno);
                if (retorno.status === 200) {
                    vm.modeloform = 4;
                    vm.mensagemUsuario = [];
                }
            }).catch(function (error) {
                vm.processando = false;
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    // console.log(error.response.headers);
                    let retorno = error.response.data;
                    if (error.response.status === 500) {
                        vm.mensagemUsuario.push("Erro no processamento: " + retorno.exception);
                    } else if (retorno.status !== 200) {
                        vm.mensagemUsuario.push(retorno.msg);
                        return;
                    }
                } else {
                    console.error(error);
                    vm.mensagemUsuario.push('Ocorreu erro na sua requisição');
                    return;
                }
            }).finally(()=>{
                vm.processando = false;
            });

        },
        async consultaCNPJ() {
            let vm = this;
            this.consultado = false;
            this.processando = false;
            let cnpj = this.cnpj;
            if (cnpj == undefined || cnpj == null) return;
            if (cnpj.length < 14) return;
            const postData = {
                cnpj: cnpj
            };
            const headers = {
                'Content-Type': 'application/json',
                'SDSPUBLIC': 'sdoasjde10929ie0d0192e09d0i1d029'
            }
            this.processando = true;
            await axios.post('services/v1/info/cnpj',
                postData, {
                    headers: headers
                }).then((response) => {
                let retorno = response.data;
                // console.log("consultaCNPJ");
                // console.dir(retorno);
                if (retorno.cnpj) {
                    this.nomeEmpresa = retorno.fantasia;
                    this.consultado = true;
                }
            }).catch(function (error) {
                this.processando = false;
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    // console.log(error.response.headers);
                    let retorno = error.response.data;
                    if (error.response.status === 500) {
                        vm.mensagemUsuario.push("Erro no processamento: " + retorno.exception);
                    } else if (retorno.status !== 200) {
                        vm.mensagemUsuario.push(retorno.msg);
                        return;
                    }
                } else {
                    console.error(error);
                    vm.mensagemUsuario.push('Ocorreu erro na sua requisição');
                    return;
                }
            }).finally(() => {
                this.processando = false;
            });
        }
    }
};
</script>

<style scoped>
.auth-anchor {
    border-style: solid;
    border-width: 1px;
    border-color: #d3d3d3;
    border-radius: 3px;
}

.auth-anchor-normal {
    height: 94px;
    width: 100%;
}

.auth-anchor-light {
    background: #f9f9f9;
    color: #000;
}

.auth-header {
    margin: 0px 5px 5px 15px;
}

.auth-texto {
    margin: 0px 1px 1px 1px;
}

.auth-resposta {

}

.auth-robot {
    margin-top: -20px;
}

.auth-empresa {
    margin: 0px;
    width: 100%;
}

.reg-form-body {
    width: 100%;
}
</style>
